import React, { useEffect, useState } from "react";
import congrats from "../assets/images/congrats.svg";
import axios from "axios";
import { getTemplateData } from "../services/apiservice";
import "../styles/feedback.css";
import Footer from "./Footer";
import Modal from "./Modal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFaceSmile as faSmile,
  faFaceFrown as faFrown,
  faFaceMeh as faMeh,
  faFaceGrinStars as faGrinStars,
} from "@fortawesome/free-regular-svg-icons";
import GradientHeader from "./GradientHeader";

const feedbackHeroImg =
  "https://content.swageazy.com/website/feedback_form_image.png";

export const FeedbackPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const onelinkRequestId = searchParams.get("onelink_request_id");
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState("");
  const [_, setCoupId] = useState();
  const [loading, setLoading] = useState(false);
  const [redirectToLinkedin, setRedirectToLinkedin] = useState(false);
  const [redemptionData, setRedemptionData] = useState({
    backroundColor: "",
    logoImageUrl: "",
    buttonColor: "",
    logoImage: "",
    footerColor: "",
    headerColor: "",
    footerText: "",
    customerId: null,
  });
  const [modalShown, setModalShown] = useState(false);
  const [selectedRating, setSelectedRating] = useState(null);
  const [customerId, setCustomerId] = useState(null);

  const ratings = [
    { value: "Average", icon: faFrown, label: "Could be better", emoji: "☹️" },
    { value: "Decent", icon: faMeh, label: "Decent", emoji: "😐" },
    { value: "Impressive", icon: faSmile, label: "Impressive", emoji: "😄" },
    { value: "Awesome", icon: faGrinStars, label: "Awesome", emoji: "😍" },
  ];

  useEffect(() => {
    if (token === null || token === "" || token === undefined) {
      window.location.href = "https://swageazy.com/";
      return;
    }
    getTemplateIdFromCoupon();
    getCouponItems();
  }, []);

  function openThankYouOrLinkedinPage() {
    if (
      customerId &&
      Number(customerId) === Number(process.env.REACT_APP_CUSTOMER_ID)
    ) {
      navigate(`/redemption/thank-you`);
    } else {
      if (redirectToLinkedin) {
        setTimeout(() => {
          window.location.href = "https://www.linkedin.com/company/swageazy";
        }, 2500);
      } else {
        navigate(`/redemption/thank-you`);
      }
    }
  }

  function getTemplateIdFromCoupon() {
    getTemplateData()
      .then((response) => {
        const data = response.data.result;
        setRedemptionData({
          backgroundColor:
            data.pageBackgroundColor || data.page_background_color,
          logoImageUrl: data.logo_image_url,
          buttonColor: data.buttonColor,
          logoImage: data.logo_image_url,
          footerColor: data.footer_color || "",
          headerColor: data.header_color || "",
          footerText: data.footer_text || "",
          customerId: data.customer_id ?? null,
        });
        setCoupId(data.id);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }

  function getCustomerConfig() {
    setLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_URL}/v5/customers/${customerId}/config/redemption`
      )
      .then((res) => {
        if (res.data.success && res.data.result) {
          setRedirectToLinkedin(
            Boolean(Number(res.data.result.redirect_redemptions_to_linkedin))
          );
        }
      })
      .catch((err) => {
        setLoading(false);
        navigate({
          pathname: "/",
        });
      });
  }

  function getCouponItems() {
    axios
      .get(
        `${process.env.REACT_APP_URL}/v4/customer/redemption/couponItems?token=${token}`
      )
      .then((res) => {
        if (res.data.success && res.data.result) {
          setCustomerId(res.data.result.customer_id);

          setRedirectToLinkedin(
            Boolean(
              Number(
                res.data.result.customer_config.redirect_redemptions_to_linkedin
              )
            )
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching coupon items:", err);
      });
  }

  const handleSubmit = async () => {
    try {
      // Find the selected rating object to get the emoji
      const selectedRatingObj = ratings.find(
        (rating) => rating.value === selectedRating
      );
      const emoji = selectedRatingObj ? selectedRatingObj.emoji : "";

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/v5/orders/users/coupon/${token}/feedback`,
        {
          rating: selectedRating,
          emoji: emoji,
          feedback_message: feedback,
          onelink_request_id: onelinkRequestId,
        }
      );

      if (response.data.success) {
        if (
          customerId &&
          Number(customerId) === Number(process.env.REACT_APP_CUSTOMER_ID)
        ) {
          navigate(`/redemption/thank-you`);
          return;
        } else {
          if (redirectToLinkedin) {
            window.location.href = "https://www.linkedin.com/company/swageazy";
          } else {
            navigate(`/redemption/thank-you`);
          }
        }
      }
    } catch (error) {}
  };

  function handleSkipForNow() {
    setModalShown(true);
    openThankYouOrLinkedinPage();
  }

  return (
    <div className="feedback-page-container feedback-flow">
      {loading ? (
        <div className="loading-indicator-admin"> </div>
      ) : (
        <>
          <div className="feedback-flow-header">
            <div
              className="top-margin-two header"
              style={{
                background: redemptionData.headerColor || "#1E1665",
              }}
            >
              {redemptionData.logoImage && (
                <div className="d-flex">
                  <GradientHeader
                    logoSrc={redemptionData.logoImage}
                    justifyContent="flex-start"
                    headerColor={redemptionData.headerColor}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="feedback-flow-body">
            <div className="feedback-card">
              <div className="feedback-card-hero">
                <div className="feedback-card-hero-copy">
                  <p className="feedback-card-kicker">Thank you</p>
                  <h1 className="feedback-card-title">
                    Your response
                    <br />
                    has been recorded!
                  </h1>
                </div>
                <div className="feedback-card-hero-visual">
                  <svg
                    className="feedback-knockout-filter"
                    aria-hidden="true"
                    focusable="false"
                  >
                    <filter
                      id="feedbackKnockoutBlack"
                      colorInterpolationFilters="sRGB"
                    >
                      <feColorMatrix
                        type="matrix"
                        values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  4 4 4 0 0"
                      />
                    </filter>
                  </svg>
                  <img
                    src={feedbackHeroImg}
                    alt=""
                    className="feedback-card-hero-img"
                  />
                </div>
              </div>

              <div className="feedback-card-body">
                <h2 className="feedback-section-title">
                  How was your experience ?
                </h2>
                <div className="feedback-ratings">
                  {ratings.map((rating) => (
                    <button
                      type="button"
                      key={rating.value}
                      className={`feedback-rating${
                        selectedRating === rating.value ? " is-selected" : ""
                      }`}
                      onClick={() => setSelectedRating(rating.value)}
                    >
                      <FontAwesomeIcon
                        icon={rating.icon}
                        className="feedback-rating-icon"
                      />
                      <span className="feedback-rating-label">
                        {rating.label}
                      </span>
                    </button>
                  ))}
                </div>

                <h2 className="feedback-section-title">Write your feedback</h2>
                <textarea
                  className="feedback-textarea"
                  placeholder="Tell us what you liked or how we can improve.."
                  rows="3"
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                />

                <div className="feedback-actions">
                  <button
                    type="button"
                    className="feedback-btn feedback-btn-skip"
                    onClick={handleSkipForNow}
                  >
                    Skip for now
                  </button>
                  <button
                    type="button"
                    className="feedback-btn feedback-btn-submit"
                    onClick={handleSubmit}
                  >
                    Submit Feedback
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="feedback-flow-footer">
            <Footer
              footerText={redemptionData.footerText}
              footerColor={redemptionData.footerColor}
              customerId={redemptionData.customerId}
            />
          </div>
          <Modal
            shown={modalShown}
            center
            classNames={{
              modal: "customModal",
              modalAnimationIn: "customEnterModalAnimation",
              modalAnimationOut: "customLeaveModalAnimation",
            }}
            animationDuration={400}
          >
            <div className="successModalContainer text-center">
              <div className="confettiSvg text-center">
                <img
                  src={congrats}
                  alt="Congratulations"
                  style={{ width: "75px", height: "75px" }}
                />
              </div>
              <div className="successContent" style={{ margin: "20px 0" }}>
                <p>
                  Loved the experience? Discover how Swageazy brings it all to
                  life.
                </p>
              </div>
            </div>
          </Modal>
        </>
      )}
    </div>
  );
};
